import React from 'react';
import { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import Modal from 'react-modal';
import 'swiper/css';
import 'swiper/css/navigation';
import { DataHtml } from './DataHtml';
import '../types/index.d.ts';

const customStylesS = {
  overlay: {
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  content: {
    top: '105px',
    backgroundColor: '#fff',
    padding: 0,
    width: '100%',
    height: '100%',
    inset: '105px 0 0',
  },
};
const customStylesM = {
  overlay: {
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: 0,
    width: '800px',
    height: 'auto',
    maxHeight: '614px',
  },
};
Modal.setAppElement('#root');

const today = new Date();
const thisYear: number = today.getFullYear();
const nextYear: number = today.getFullYear() + 1;
const afterNextYear: number = today.getFullYear() + 2;
const thisMonth: number = today.getMonth(); // 0からカウント
let year = thisYear;

const url = new URL(window.location.href);
const params = url.searchParams;
const domain = url.hostname;

const brand_xiv = [
  {
    title: `エクシブ 26泊 ${thisYear}`,
    product_code: 51,
    year: thisYear,
    test: false,
  },
  {
    title: `エクシブ 26泊 ${nextYear}`,
    product_code: 51,
    year: nextYear,
    test: false,
  },
  {
    title: `エクシブ 26泊 ${afterNextYear}`,
    product_code: 51,
    year: afterNextYear,
    test: true,
  },
  {
    title: `バージョン 13泊 ${thisYear}`,
    product_code: 81,
    year: thisYear,
    test: false,
  },
  {
    title: `バージョン 13泊 ${nextYear}`,
    product_code: 81,
    year: nextYear,
    test: false,
  },
  {
    title: `バージョン 13泊 ${afterNextYear}`,
    product_code: 81,
    year: afterNextYear,
    test: true,
  },
  {
    title: `バージョン 13泊連泊 ${thisYear}`,
    product_code: 65,
    year: thisYear,
    test: false,
  },
  {
    title: `バージョン 13泊連泊 ${nextYear}`,
    product_code: 65,
    year: nextYear,
    test: false,
  },
  {
    title: `バージョン 13泊連泊 ${afterNextYear}`,
    product_code: 65,
    year: afterNextYear,
    test: true,
  },
  {
    title: `エクシブ10 ${thisYear}`,
    product_code: 86,
    year: thisYear,
    test: false,
  },
  {
    title: `エクシブ10 ${nextYear}`,
    product_code: 86,
    year: nextYear,
    test: false,
  },
  {
    title: `エクシブ10 ${afterNextYear}`,
    product_code: 86,
    year: afterNextYear,
    test: true,
  },
];

const brand_baycourt = [
  {
    title: `東京/横浜 24泊 ${thisYear}`,
    product_code: 71,
    year: thisYear,
    test: false,
  },
  {
    title: `東京/横浜 24泊 ${nextYear}`,
    product_code: 71,
    year: nextYear,
    test: false,
  },
  {
    title: `東京/横浜 24泊 ${afterNextYear}`,
    product_code: 71,
    year: afterNextYear,
    test: true,
  },
  {
    title: `東京/横浜 12泊 ${thisYear}`,
    product_code: 75,
    year: thisYear,
    test: false,
  },
  {
    title: `東京/横浜 12泊 ${nextYear}`,
    product_code: 75,
    year: nextYear,
    test: false,
  },
  {
    title: `東京/横浜 12泊 ${afterNextYear}`,
    product_code: 75,
    year: afterNextYear,
    test: true,
  },
  {
    title: `ラグーナ/芦屋 24泊 ${thisYear}`,
    product_code: 72,
    year: thisYear,
    test: false,
  },
  {
    title: `ラグーナ/芦屋 24泊 ${nextYear}`,
    product_code: 72,
    year: nextYear,
    test: false,
  },
  {
    title: `ラグーナ/芦屋 24泊 ${afterNextYear}`,
    product_code: 72,
    year: afterNextYear,
    test: true,
  },
  {
    title: `ラグーナ/芦屋 12泊 ${thisYear}`,
    product_code: 76,
    year: thisYear,
    test: false,
  },
  {
    title: `ラグーナ/芦屋 12泊 ${nextYear}`,
    product_code: 76,
    year: nextYear,
    test: false,
  },
  {
    title: `ラグーナ/芦屋 12泊 ${afterNextYear}`,
    product_code: 76,
    year: afterNextYear,
    test: true,
  },
];

const brand_sanctuarycourt = [
  {
    title: `高山 20泊 ${thisYear}`,
    product_code: 91,
    year: thisYear,
    test: false,
  },
  {
    title: `高山 20泊 ${nextYear}`,
    product_code: 91,
    year: nextYear,
    test: false,
  },
  {
    title: `高山 20泊 ${afterNextYear}`,
    product_code: 91,
    year: afterNextYear,
    test: true,
  },
  {
    title: `高山 10泊 ${thisYear}`,
    product_code: 93,
    year: thisYear,
    test: false,
  },
  {
    title: `高山 10泊 ${nextYear}`,
    product_code: 93,
    year: nextYear,
    test: false,
  },
  {
    title: `高山 10泊 ${afterNextYear}`,
    product_code: 93,
    year: afterNextYear,
    test: true,
  },
  // {
  //   title: `琵琶湖 20泊 ${thisYear}`,
  //   product_code: 92,
  //   year: thisYear,
  //   test: false,
  // },
  // {
  //   title: `琵琶湖 20泊 ${nextYear}`,
  //   product_code: 92,
  //   year: nextYear,
  //   test: false,
  // },
  // {
  //   title: `琵琶湖 20泊 ${afterNextYear}`,
  //   product_code: 92,
  //   year: afterNextYear,
  //   test: true,
  // },
  // {
  //   title: `琵琶湖 10泊 ${thisYear}`,
  //   product_code: 94,
  //   year: thisYear,
  //   test: false,
  // },
  // {
  //   title: `琵琶湖 10泊 ${nextYear}`,
  //   product_code: 94,
  //   year: nextYear,
  //   test: false,
  // },
  // {
  //   title: `琵琶湖 10泊 ${afterNextYear}`,
  //   product_code: 94,
  //   year: afterNextYear,
  //   test: true,
  // },
];

let selectedProduct = ''; // 初期値

selectedProduct = params.get('product') as string;

let selectedBrands: SelectedBrands[] = [];
let selectedValue = ''; // 商品セレクトタグのデフォルト値用

switch (selectedProduct) {
  case '51':
    selectedBrands = brand_xiv;
    selectedValue = brand_xiv[0].title;
    break;
  case '81':
    selectedBrands = brand_xiv;
    selectedValue = brand_xiv[3].title;
    break;
  case '65':
    selectedBrands = brand_xiv;
    selectedValue = brand_xiv[6].title;
    break;
  case '86':
    selectedBrands = brand_xiv;
    selectedValue = brand_xiv[9].title;
    break;
  case '71':
    selectedBrands = brand_baycourt;
    selectedValue = brand_baycourt[0].title;
    break;
  case '75':
    selectedBrands = brand_baycourt;
    selectedValue = brand_baycourt[3].title;
    break;
  case '72':
    selectedBrands = brand_baycourt;
    selectedValue = brand_baycourt[6].title;
    break;
  case '76':
    selectedBrands = brand_baycourt;
    selectedValue = brand_baycourt[9].title;
    break;
  case '91':
    selectedBrands = brand_sanctuarycourt;
    selectedValue = brand_sanctuarycourt[0].title;
    break;
  case '93':
    selectedBrands = brand_sanctuarycourt;
    selectedValue = brand_sanctuarycourt[3].title;
    break;
  case '92':
    selectedBrands = brand_sanctuarycourt;
    selectedValue = brand_sanctuarycourt[6].title;
    break;
  case '94':
    selectedBrands = brand_sanctuarycourt;
    selectedValue = brand_sanctuarycourt[9].title;
    break;
}

// ステージングだけ今年、来年、再来年のセレクトタグを表示する
let selectedBrandsFiltered: SelectedBrands[] = [];
if (domain === 'test.rtg.jp') {
  selectedBrandsFiltered = selectedBrands; // そのまま
} else {
  selectedBrandsFiltered = selectedBrands.filter((obj) => obj.test === false); // 再来年以外を抽出
}

const brands = selectedBrandsFiltered.map((obj) => obj.title);

// let endpoint = '/test/test.json';
let endpoint = `https://${process.env.REACT_APP_API_ENDPOINT_DOMAIN}/timeshare/ts-system/api/calendar?product_code=${selectedProduct}&year=${year}`;

export const Content: React.FC = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [checkboxValuesTemp, setCheckboxValuesTemp] = useState<string[]>([]);
  const [checkboxValues, setCheckboxValues] = useState<string[]>([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [calendarsMax, setCalendarsMax] = useState<number>(0); // 「カレンダーNo.で絞り込む」のNo数

  useEffect(() => {
    axios
      .get(endpoint)
      .then((res) => {
        setData(res.data);
        if (res.data.length) {
          const calendars = res.data.map((x: Data) => x['calendar']);
          setCalendarsMax(Math.max(...calendars));
        }
      })
      .catch((err) => {
        setData(err);
      });
  }, []);

  const productNumber = [...Array(calendarsMax)].map((_, i) => i);

  const isTabletAndDesktop = useMediaQuery({
    query: '(min-width: 768px)',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    if (checkboxValuesTemp.includes(value)) {
      setCheckboxValuesTemp(checkboxValuesTemp.filter((x: string) => x !== value));
    } else {
      setCheckboxValuesTemp([...checkboxValuesTemp, value]);
    }
  };

  const filterCalendar = () => {
    setCheckboxValues(checkboxValuesTemp);
  };

  const changeProduct = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setData([]);
    setCheckboxValuesTemp([]);
    setCheckboxValues([]);
    setIsLoading(true);

    selectedValue = e.target.value;

    let product_code = '';

    selectedBrands.forEach((elm) => {
      if (elm.title === selectedValue) {
        product_code = String(elm.product_code);
        year = elm.year;
      }
    });

    // endpoint = '/test/test2.json';
    endpoint = `https://${process.env.REACT_APP_API_ENDPOINT_DOMAIN}/timeshare/ts-system/api/calendar?product_code=${product_code}&year=${year}`;

    axios
      .get(endpoint)
      .then((res) => {
        setData(res.data);
        setIsLoading(false);
        if (res.data.length) {
          const calendars = res.data.map((x: Data) => x['calendar']);
          setCalendarsMax(Math.max(...calendars));
        } else if (res.data.length === 0) {
          setCalendarsMax(0);
        }
      })
      .catch((err) => {
        setData(err);
        setIsLoading(false);
      });
  };

  const changeFilterBtnText = (checkboxValues: string[]) => {
    return checkboxValues.map((value: string, i: number) => {
      const temp = value.replace('no-', ' ');
      if (checkboxValues.length - 1 === i) {
        return temp;
      } else {
        return temp.replace(temp, temp + ',');
      }
    });
  };

  const Loading = () => <p>ロード中...</p>;

  return (
    <>
      <div className='mt-[-23px] px-[15px]'>
        <div className='rounded-t-[5px] bg-white px-[15px] pt-[32px] pb-[60px] md:mx-auto md:mt-[-50px] md:max-w-[1160px] md:px-[50px] md:pb-[80px]'>
          <div className='md:flex'>
            <div>
              <p className='text-[1.4rem]'>商品</p>
              <select onChange={(e) => changeProduct(e)} value={selectedValue} css={select}>
                {brands.map((brand) => {
                  return (
                    <option value={brand} key={brand}>
                      {brand}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className='mt-[22px] md:mt-0 md:ml-[34px]'>
              <p className='text-[1.4rem]'>カレンダーNo.で絞り込む</p>
              <button
                onClick={() => setIsOpen(true)}
                css={btnModal}
                className='whitespace-nowrap'
                disabled={calendarsMax ? false : true}
              >
                {checkboxValues.length ? changeFilterBtnText(checkboxValues) : '選択してください'}
              </button>
            </div>
          </div>
          <Modal
            isOpen={modalIsOpen}
            style={isTabletAndDesktop ? customStylesM : customStylesS}
            onRequestClose={() => setIsOpen(false)}
          >
            <div className='bg-[#F7F7F7] pb-[100px] md:pb-0' css={modal}>
              <div className='w-[312px] w-auto py-[50px] px-[30px] md:mx-auto md:px-[100px]'>
                <button
                  onClick={() => setIsOpen(false)}
                  className='un-closeBtn absolute top-[15px] right-[15px] inline-block h-[20px] w-[20px] text-[0px] md:right-[30px]'
                >
                  閉じる
                </button>
                <p className='md:mx-auto md:w-[530px]'>カレンダーNo.を選択してください</p>
                <ul className='mt-[20px] flex flex-wrap justify-center gap-[12px] md:mx-auto md:w-[530px]'>
                  {productNumber.map((x) => {
                    return (
                      <li key={x}>
                        <label className='flex h-[48px] w-[96px] items-center justify-center bg-white text-[1.4rem]'>
                          <input
                            type='checkbox'
                            value={'no-' + (x + 1)}
                            onChange={(e) => handleChange(e)}
                            checked={checkboxValuesTemp.includes('no-' + (x + 1))}
                            className='mr-[5px]'
                          />
                          <span></span>
                          No.{String(x + 1)}
                        </label>
                      </li>
                    );
                  })}
                  <li className='h-0 w-[96px]'></li>
                  <li className='h-0 w-[96px]'></li>
                  <li className='h-0 w-[96px]'></li>
                  <li className='h-0 w-[96px]'></li>
                </ul>
              </div>
              <div className='flex justify-center gap-[16px] bg-white p-[32px]'>
                <button
                  onClick={() => {
                    setCheckboxValuesTemp([]), setCheckboxValues([]);
                  }}
                  className='flex h-[44px] w-[167px] items-center justify-center border-[1px] border-[#DDDDDD] bg-[#F7F7F7] transition duration-300 hover:opacity-[0.8]'
                >
                  リセット
                </button>
                <button
                  onClick={() => {
                    filterCalendar(), setIsOpen(false);
                  }}
                  className='flex h-[44px] w-[167px] items-center justify-center bg-black text-white transition duration-300  hover:opacity-[0.8]'
                >
                  絞り込み
                </button>
              </div>
            </div>
          </Modal>
          <p className='mt-[38px] border-l-[4px] border-[#C0B283] pl-[10px] text-[2.4rem] leading-[1] md:mt-[57px] md:pl-[13px] md:text-[3.2rem]'>
            {year}
          </p>
          <div className={checkboxValues.join(' ')} css={calendarWrap}>
            {isLoading ? (
              <Loading />
            ) : (
              <DataHtml
                data={data}
                isTabletAndDesktop={isTabletAndDesktop}
                year={year}
                thisMonth={thisMonth}
              />
            )}
          </div>
          <p className='mt-[30px] text-center md:mt-[60px]'>
            <a href='/timeshare/' className='border-b-[1px] border-black pb-[5px]'>
              戻る
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

const select = css`
  appearance: none;
  padding: 12px 36px 12px 12px;
  margin-top: 7px;
  background-color: #f7f7f7;
  font-size: 1.4rem;
  border: 1px solid #dddddd;
  overflow-wrap: break-word;
  width: 100%;
  background: url(./img/ico_select.svg) no-repeat right 15px top 50% #f7f7f7;
  @media (min-width: 768px) {
    font-size: 1.6rem;
  }
`;

const btnModal = css`
  margin-top: 9px;
  border: 1px solid #ddd;
  background-color: #f7f7f7f7;
  padding: 11px 50px 11px 15px;
  font-size: 1.4rem;
  background: url(./img/ico_modal.svg) no-repeat right 12px top 50% #f7f7f7;
  @media (min-width: 768px) {
    margin-top: 7px;
    font-size: 1.6rem;
  }
  &:disabled {
    opacity: 0.7;
  }
`;

const calendarWrap = css`
  margin-top: 30px;
  @media (min-width: 768px) {
    margin-top: 38px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    top: 7%;
    width: 34px;
    height: 8px;
    &::after {
      content: '';
      width: 34px;
      height: 8px;
    }
  }
  .swiper-button-next {
    &::after {
      background: url(./img/btn_arrow_next.svg) no-repeat center;
    }
  }
  .swiper-button-prev {
    &::after {
      content: '';
      background: url(./img/btn_arrow_prev.svg) no-repeat center;
    }
  }
  &.no-1 {
    td {
      opacity: 0.2;
      &.no-1 {
        opacity: 1;
      }
    }
  }
  &.no-2 {
    td {
      opacity: 0.2;
      &.no-2 {
        opacity: 1;
      }
    }
  }
  &.no-3 {
    td {
      opacity: 0.2;
      &.no-3 {
        opacity: 1;
      }
    }
  }
  &.no-4 {
    td {
      opacity: 0.2;
      &.no-4 {
        opacity: 1;
      }
    }
  }
  &.no-5 {
    td {
      opacity: 0.2;
      &.no-5 {
        opacity: 1;
      }
    }
  }
  &.no-6 {
    td {
      opacity: 0.2;
      &.no-6 {
        opacity: 1;
      }
    }
  }
  &.no-7 {
    td {
      opacity: 0.2;
      &.no-7 {
        opacity: 1;
      }
    }
  }
  &.no-8 {
    td {
      opacity: 0.2;
      &.no-8 {
        opacity: 1;
      }
    }
  }
  &.no-9 {
    td {
      opacity: 0.2;
      &.no-9 {
        opacity: 1;
      }
    }
  }
  &.no-10 {
    td {
      opacity: 0.2;
      &.no-10 {
        opacity: 1;
      }
    }
  }
  &.no-11 {
    td {
      opacity: 0.2;
      &.no-11 {
        opacity: 1;
      }
    }
  }
  &.no-12 {
    td {
      opacity: 0.2;
      &.no-12 {
        opacity: 1;
      }
    }
  }
  &.no-13 {
    td {
      opacity: 0.2;
      &.no-13 {
        opacity: 1;
      }
    }
  }
  &.no-14 {
    td {
      opacity: 0.2;
      &.no-14 {
        opacity: 1;
      }
    }
  }
  &.no-15 {
    td {
      opacity: 0.2;
      &.no-15 {
        opacity: 1;
      }
    }
  }
  &.no-16 {
    td {
      opacity: 0.2;
      &.no-16 {
        opacity: 1;
      }
    }
  }
  &.no-17 {
    td {
      opacity: 0.2;
      &.no-17 {
        opacity: 1;
      }
    }
  }
  &.no-18 {
    td {
      opacity: 0.2;
      &.no-18 {
        opacity: 1;
      }
    }
  }
  &.no-19 {
    td {
      opacity: 0.2;
      &.no-19 {
        opacity: 1;
      }
    }
  }
  &.no-20 {
    td {
      opacity: 0.2;
      &.no-20 {
        opacity: 1;
      }
    }
  }
  &.no-21 {
    td {
      opacity: 0.2;
      &.no-21 {
        opacity: 1;
      }
    }
  }
  &.no-22 {
    td {
      opacity: 0.2;
      &.no-22 {
        opacity: 1;
      }
    }
  }
  &.no-23 {
    td {
      opacity: 0.2;
      &.no-23 {
        opacity: 1;
      }
    }
  }
  &.no-24 {
    td {
      opacity: 0.2;
      &.no-24 {
        opacity: 1;
      }
    }
  }
  &.no-25 {
    td {
      opacity: 0.2;
      &.no-25 {
        opacity: 1;
      }
    }
  }
  &.no-26 {
    td {
      opacity: 0.2;
      &.no-26 {
        opacity: 1;
      }
    }
  }
  &.no-27 {
    td {
      opacity: 0.2;
      &.no-27 {
        opacity: 1;
      }
    }
  }
  &.no-28 {
    td {
      opacity: 0.2;
      &.no-28 {
        opacity: 1;
      }
    }
  }
  &.no-29 {
    td {
      opacity: 0.2;
      &.no-29 {
        opacity: 1;
      }
    }
  }
  &.no-30 {
    td {
      opacity: 0.2;
      &.no-30 {
        opacity: 1;
      }
    }
  }
  &.no-31 {
    td {
      opacity: 0.2;
      &.no-31 {
        opacity: 1;
      }
    }
  }
  &.no-32 {
    td {
      opacity: 0.2;
      &.no-32 {
        opacity: 1;
      }
    }
  }
  &.no-33 {
    td {
      opacity: 0.2;
      &.no-33 {
        opacity: 1;
      }
    }
  }
  &.no-34 {
    td {
      opacity: 0.2;
      &.no-34 {
        opacity: 1;
      }
    }
  }
  &.no-35 {
    td {
      opacity: 0.2;
      &.no-35 {
        opacity: 1;
      }
    }
  }
  &.no-36 {
    td {
      opacity: 0.2;
      &.no-36 {
        opacity: 1;
      }
    }
  }
  &.no-37 {
    td {
      opacity: 0.2;
      &.no-37 {
        opacity: 1;
      }
    }
  }
  &.no-38 {
    td {
      opacity: 0.2;
      &.no-38 {
        opacity: 1;
      }
    }
  }
  &.no-39 {
    td {
      opacity: 0.2;
      &.no-39 {
        opacity: 1;
      }
    }
  }
  &.no-40 {
    td {
      opacity: 0.2;
      &.no-40 {
        opacity: 1;
      }
    }
  }
  &.no-41 {
    td {
      opacity: 0.2;
      &.no-41 {
        opacity: 1;
      }
    }
  }
  &.no-42 {
    td {
      opacity: 0.2;
      &.no-42 {
        opacity: 1;
      }
    }
  }
  &.no-43 {
    td {
      opacity: 0.2;
      &.no-43 {
        opacity: 1;
      }
    }
  }
  &.no-44 {
    td {
      opacity: 0.2;
      &.no-44 {
        opacity: 1;
      }
    }
  }
  &.no-45 {
    td {
      opacity: 0.2;
      &.no-45 {
        opacity: 1;
      }
    }
  }
  &.no-46 {
    td {
      opacity: 0.2;
      &.no-46 {
        opacity: 1;
      }
    }
  }
  &.no-47 {
    td {
      opacity: 0.2;
      &.no-47 {
        opacity: 1;
      }
    }
  }
  &.no-48 {
    td {
      opacity: 0.2;
      &.no-48 {
        opacity: 1;
      }
    }
  }
  &.no-49 {
    td {
      opacity: 0.2;
      &.no-49 {
        opacity: 1;
      }
    }
  }
  &.no-50 {
    td {
      opacity: 0.2;
      &.no-50 {
        opacity: 1;
      }
    }
  }
  &.no-51 {
    td {
      opacity: 0.2;
      &.no-51 {
        opacity: 1;
      }
    }
  }
  &.no-52 {
    td {
      opacity: 0.2;
      &.no-52 {
        opacity: 1;
      }
    }
  }
  &.no-53 {
    td {
      opacity: 0.2;
      &.no-53 {
        opacity: 1;
      }
    }
  }
  &.no-54 {
    td {
      opacity: 0.2;
      &.no-54 {
        opacity: 1;
      }
    }
  }
  &.no-55 {
    td {
      opacity: 0.2;
      &.no-55 {
        opacity: 1;
      }
    }
  }
  &.no-56 {
    td {
      opacity: 0.2;
      &.no-56 {
        opacity: 1;
      }
    }
  }
  &.no-57 {
    td {
      opacity: 0.2;
      &.no-57 {
        opacity: 1;
      }
    }
  }
  &.no-58 {
    td {
      opacity: 0.2;
      &.no-58 {
        opacity: 1;
      }
    }
  }
  &.no-59 {
    td {
      opacity: 0.2;
      &.no-59 {
        opacity: 1;
      }
    }
  }
  &.no-60 {
    td {
      opacity: 0.2;
      &.no-60 {
        opacity: 1;
      }
    }
  }
  &.no-61 {
    td {
      opacity: 0.2;
      &.no-61 {
        opacity: 1;
      }
    }
  }
  &.no-62 {
    td {
      opacity: 0.2;
      &.no-62 {
        opacity: 1;
      }
    }
  }
  &.no-63 {
    td {
      opacity: 0.2;
      &.no-63 {
        opacity: 1;
      }
    }
  }
  &.no-64 {
    td {
      opacity: 0.2;
      &.no-64 {
        opacity: 1;
      }
    }
  }
  &.no-65 {
    td {
      opacity: 0.2;
      &.no-65 {
        opacity: 1;
      }
    }
  }
  &.no-66 {
    td {
      opacity: 0.2;
      &.no-66 {
        opacity: 1;
      }
    }
  }
  &.no-67 {
    td {
      opacity: 0.2;
      &.no-67 {
        opacity: 1;
      }
    }
  }
  &.no-68 {
    td {
      opacity: 0.2;
      &.no-68 {
        opacity: 1;
      }
    }
  }
  &.no-69 {
    td {
      opacity: 0.2;
      &.no-69 {
        opacity: 1;
      }
    }
  }
  &.no-70 {
    td {
      opacity: 0.2;
      &.no-70 {
        opacity: 1;
      }
    }
  }
  &.no-71 {
    td {
      opacity: 0.2;
      &.no-71 {
        opacity: 1;
      }
    }
  }
  &.no-72 {
    td {
      opacity: 0.2;
      &.no-72 {
        opacity: 1;
      }
    }
  }
  &.no-73 {
    td {
      opacity: 0.2;
      &.no-73 {
        opacity: 1;
      }
    }
  }
  &.no-74 {
    td {
      opacity: 0.2;
      &.no-74 {
        opacity: 1;
      }
    }
  }
  &.no-75 {
    td {
      opacity: 0.2;
      &.no-75 {
        opacity: 1;
      }
    }
  }
  &.no-76 {
    td {
      opacity: 0.2;
      &.no-76 {
        opacity: 1;
      }
    }
  }
  &.no-77 {
    td {
      opacity: 0.2;
      &.no-77 {
        opacity: 1;
      }
    }
  }
  &.no-78 {
    td {
      opacity: 0.2;
      &.no-78 {
        opacity: 1;
      }
    }
  }
  &.no-79 {
    td {
      opacity: 0.2;
      &.no-79 {
        opacity: 1;
      }
    }
  }
  &.no-80 {
    td {
      opacity: 0.2;
      &.no-80 {
        opacity: 1;
      }
    }
  }
  &.no-81 {
    td {
      opacity: 0.2;
      &.no-81 {
        opacity: 1;
      }
    }
  }
  &.no-82 {
    td {
      opacity: 0.2;
      &.no-82 {
        opacity: 1;
      }
    }
  }
  &.no-83 {
    td {
      opacity: 0.2;
      &.no-83 {
        opacity: 1;
      }
    }
  }
  &.no-84 {
    td {
      opacity: 0.2;
      &.no-84 {
        opacity: 1;
      }
    }
  }
  &.no-85 {
    td {
      opacity: 0.2;
      &.no-85 {
        opacity: 1;
      }
    }
  }
  &.no-86 {
    td {
      opacity: 0.2;
      &.no-86 {
        opacity: 1;
      }
    }
  }
  &.no-87 {
    td {
      opacity: 0.2;
      &.no-87 {
        opacity: 1;
      }
    }
  }
  &.no-88 {
    td {
      opacity: 0.2;
      &.no-88 {
        opacity: 1;
      }
    }
  }
  &.no-89 {
    td {
      opacity: 0.2;
      &.no-89 {
        opacity: 1;
      }
    }
  }
  &.no-90 {
    td {
      opacity: 0.2;
      &.no-90 {
        opacity: 1;
      }
    }
  }
  &.no-91 {
    td {
      opacity: 0.2;
      &.no-91 {
        opacity: 1;
      }
    }
  }
  &.no-92 {
    td {
      opacity: 0.2;
      &.no-92 {
        opacity: 1;
      }
    }
  }
  &.no-93 {
    td {
      opacity: 0.2;
      &.no-93 {
        opacity: 1;
      }
    }
  }
  &.no-94 {
    td {
      opacity: 0.2;
      &.no-94 {
        opacity: 1;
      }
    }
  }
  &.no-95 {
    td {
      opacity: 0.2;
      &.no-95 {
        opacity: 1;
      }
    }
  }
  &.no-96 {
    td {
      opacity: 0.2;
      &.no-96 {
        opacity: 1;
      }
    }
  }
  &.no-97 {
    td {
      opacity: 0.2;
      &.no-97 {
        opacity: 1;
      }
    }
  }
  &.no-98 {
    td {
      opacity: 0.2;
      &.no-98 {
        opacity: 1;
      }
    }
  }
  &.no-99 {
    td {
      opacity: 0.2;
      &.no-99 {
        opacity: 1;
      }
    }
  }
  &.no-100 {
    td {
      opacity: 0.2;
      &.no-100 {
        opacity: 1;
      }
    }
  }
`;

const modal = css`
  label {
    span {
      display: inline-block;
      position: relative;
      top: -1px;
      width: 18px;
      height: 18px;
      background: url(./img/btn_check_off.svg) no-repeat center;
      margin-right: 10px;
    }
  }
  input[type='checkbox'] {
    position: absolute;
    appearance: none;
    &:checked + span {
      background-image: url(./img/btn_check_on.svg);
    }
    &:focus {
      // キー操作用
      width: 96px;
      height: 48px;
    }
  }
  .un-closeBtn {
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 1px;
      height: 20px;
      background-color: #000;
    }
    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
`;
